import { defineComponent, ref, computed, onMounted, resolveComponent, createElementBlock, createCommentVNode, openBlock, createVNode, createElementVNode, toDisplayString, unref } from "vue";
import { useI18n } from "vue-i18n";
import { PaymentTypeLabel } from "app-core";
const _hoisted_1 = {
  key: 0,
  class: "payment-qr"
};
const _hoisted_2 = { class: "mt-2" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ReceiptPaymentQrCode",
  props: {
    order: {
      type: Object,
      required: true
    },
    /** The receipt's venue — whose bank account the code pays to (falls back to the logged-in tenant's). */
    venue: {
      type: Object,
      default: void 0
    }
  },
  setup(__props) {
    const props = __props;
    const { t } = useI18n();
    const paymentQrCode = ref(null);
    const isInvoicePayment = computed(() => {
      return props.order.getPayments().some(
        (p) => p.key === PaymentTypeLabel.invoice
      );
    });
    onMounted(() => {
      paymentQrCode.value = props.order.getPaymentQRCode(props.venue);
    });
    return (_ctx, _cache) => {
      const _component_vue_qrcode = resolveComponent("vue-qrcode");
      return isInvoicePayment.value && !!paymentQrCode.value ? (openBlock(), createElementBlock("div", _hoisted_1, [
        createVNode(_component_vue_qrcode, {
          value: paymentQrCode.value,
          options: {
            width: 80,
            errorCorrectionLevel: "L",
            margin: 1,
            scale: 6
          },
          tag: "img"
        }, null, 8, ["value"]),
        createElementVNode("span", _hoisted_2, toDisplayString(unref(t)("order.payment_qr_code")), 1)
      ])) : createCommentVNode("", true);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=index105.js.map
